var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ctm-webhook-settings" },
    [
      _vm.loading
        ? _c("div", { staticClass: "ctm-webhook-settings__loading" }, [
            _c("i", { staticClass: "el-icon-loading" }),
            _vm._v(" Loading…\n    ")
          ])
        : [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "el-form",
              {
                staticClass: "ctm-webhook-settings__form",
                attrs: { "label-position": "top" }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Default Webhook URL" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "https://hooks.zapier.com/hooks/catch/…",
                        clearable: ""
                      },
                      model: {
                        value: _vm.settings.default_url,
                        callback: function($$v) {
                          _vm.$set(_vm.settings, "default_url", $$v)
                        },
                        expression: "settings.default_url"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "ctm-webhook-settings__help" }, [
                      _vm._v(
                        "\n                    Optional. Used as a fallback when a form has no URL configured.\n                "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "Default Request Format" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "220px" },
                        model: {
                          value: _vm.settings.request_format,
                          callback: function($$v) {
                            _vm.$set(_vm.settings, "request_format", $$v)
                          },
                          expression: "settings.request_format"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "JSON (recommended)", value: "json" }
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "Form Encoded", value: "form" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ctm-webhook-settings__payload-preview" },
              [
                _c(
                  "p",
                  { staticClass: "ctm-webhook-settings__payload-label" },
                  [_vm._v("Example payload sent on submission:")]
                ),
                _vm._v(" "),
                _c(
                  "pre",
                  { staticClass: "ctm-webhook-settings__payload-code" },
                  [_vm._v(_vm._s(_vm.examplePayload))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ctm-webhook-settings__actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.saving },
                    on: { click: _vm.save }
                  },
                  [_vm._v("Save Settings")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      loading: _vm.testing,
                      disabled: !_vm.settings.default_url
                    },
                    on: { click: _vm.sendTest }
                  },
                  [_vm._v("Send Test")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.testResult
              ? _c(
                  "div",
                  {
                    class: [
                      "ctm-webhook-settings__test-result",
                      _vm.testResult.ok ? "is-success" : "is-error"
                    ]
                  },
                  [
                    _c("i", {
                      class: _vm.testResult.ok
                        ? "el-icon-circle-check"
                        : "el-icon-circle-close"
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.testResult.message) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-webhook-settings__header" }, [
      _c("span", {
        staticClass: "ctm-webhook-settings__icon dashicons dashicons-rest-api"
      }),
      _vm._v(" "),
      _c("div", [
        _c("h2", { staticClass: "ctm-webhook-settings__title" }, [
          _vm._v("Webhook / Zapier")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "ctm-webhook-settings__desc" }, [
          _vm._v(
            "\n                    POST form submissions to any URL — Zapier, Make, n8n, or your own endpoint.\n                    Configure a default URL here; each form can also set its own URL.\n                "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }